import { Grid, IconButton, Typography, useMediaQuery, ClickAwayListener, Paper } from '@mui/material'
import clsx from "clsx";
import { useCallback, useContext, useRef, useState } from 'react'
import styles from "../../../assets/styles/componentStyles/chatbotStyles/chats.module.scss";
import mobileStyles from "../../../assets/styles/componentStyles/chatbotStyles/chatsMobileResponsive.module.scss";
import { ChatbotContext, ChatbotContextPayload } from '../../../context/chatbotContext';
import IconsColor from '../../../components/utility/iconsColor';
import { hasInboxReadAccess, isAdmin } from '../../../utils/constants';
import { primaryColor, secondaryColor, whiteColor, archiveBtnBgColor, unArchiveBtnBgColor, greyColor, redColor } from '../../../utils/colors';
import globalStyles from "../../../assets/styles/global.module.scss";
import { UserContext, UserContextPayload } from '../../../context/userContext';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { renderAllAssignedAgentAvatar, renderUserAvatarDp } from '../renderUtils';
import { currentActiveChatbotThreadTypeNew } from '../../../models/axiosModel';
import { useSearchParams } from 'react-router-dom';
import GlobalButton from '../../../components/utility/globalButton/button';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { useInboxThreadMenuActions } from '../hooks/useInboxThreadMenuActions'
import GlobalTooltip from '../../../components/utility/tooltip/globalTooltip';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useVoiceCallStore } from '../../../store/voiceCallStore';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import { ACTION_TYPE_NAME } from '../../../components/dashboard/flowBuilder/flowBuilderConstants';
import { useRuleBasedInboxStore } from '../../../store/ruleBasedInboxStore';
import { useShallow } from 'zustand/react/shallow';
import LogoutIcon from '@mui/icons-material/Logout';
import { formatPhoneNumber, getActionButtonColors, getDynamicColorsBySource, getMetadataValue, getThreadInstagramUserName, isChannelNameChronoxAiWebApp, isChannelNameChronoxAiWebAppOrWebsite, isChannelNameWhatsApp, isConversationHandleByOtherAgent, isOnlySmbUserAssigned, isThreadArchived } from '../../../pages/ruleBasedInbox/utils';
import { MANUAL_OVERRIDE_BTN_TEXT, METADATA_KEYS, VOICE_CALL_STATUS } from '../constants';
import { isInstagramChannel } from '../channelConstants';

interface ThreadLogHeaderProps {
    getSpecificChat: (chatbot_user_id: number | string, offSetValue: number, flag_debug: boolean, flagViewDetailedLog: boolean, forceRefresh?: boolean) => void,
    handleToggleManualOverride: (user_assignment_id: string, flag_delete_agent: boolean) => void,
    getManualOverrideConfig: (currentActiveChatbotThread: currentActiveChatbotThreadTypeNew | null) => string,
    flagRuleBasedInbox?: boolean,
    onArchiveToggle?: (threadId: string, flagArchive: boolean) => void,
    onRefreshThread?: () => void,
    getDynamicColorsByChatbotRouteSource: (source?: string) => ReturnType<typeof getDynamicColorsBySource>,
}

function ThreadLogHeader(props: ThreadLogHeaderProps) {
    const {
        getSpecificChat,
        handleToggleManualOverride,
        getManualOverrideConfig,
        flagRuleBasedInbox,
        onArchiveToggle,
        onRefreshThread,
        getDynamicColorsByChatbotRouteSource
    } = props;

    const { isVoiceCallingEnableWaba, setFlagVoiceCallPopup } = useVoiceCallStore(useShallow((state) => ({
        isVoiceCallingEnableWaba: state.isVoiceCallingEnableWaba,
        setFlagVoiceCallPopup: state.setFlagVoiceCallPopup
    })))

    const {
        newThreadInfo, currentActiveChatbotThread, setCurrentActiveChatbotThread,
        setChatClicked, chatLevelMenu, setChatlevelMenu,
        handleAnimationOnClickOfManualOverrideBtn, setFlagOpenThreadInfoBlock, setChatInfoClicked,
        flagRenderNewConversation
    } = useRuleBasedInboxStore(
        useShallow((state) => ({
            newThreadInfo: state.newThreadInfo,
            currentActiveChatbotThread: state.currentActiveChatbotThread,
            setCurrentActiveChatbotThread: state.setCurrentActiveChatbotThread,
            setChatClicked: state.setChatClicked,
            chatLevelMenu: state.chatLevelMenu,
            setChatlevelMenu: state.setChatlevelMenu,
            handleAnimationOnClickOfManualOverrideBtn: state.handleAnimationOnClickOfManualOverrideBtn,
            setFlagOpenThreadInfoBlock: state.setFlagOpenThreadInfoBlock,
            setChatInfoClicked: state.setChatInfoClicked,
            flagRenderNewConversation: state.flagRenderNewConversation
        }))
    )

    const { chatBotDetails } = useContext(ChatbotContext) as ChatbotContextPayload;
    const { userDetail, apiRoutesPermissionAssignment } = useContext(UserContext) as UserContextPayload;
    const {
        renderChatLevelMenu,
        shouldShowManualOverrideBtn,
        shouldShowArchiveActionBtn,
        checkDisabledManualOverRideBtn,
        getArchiveActionState,
    } = useInboxThreadMenuActions({
        getSpecificChat,
        handleToggleManualOverride,
        getManualOverrideConfig,
        flagRuleBasedInbox,
        onArchiveToggle,
    });

    const actionBtnColors = getActionButtonColors(currentActiveChatbotThread?.chatbot_user_route_source, currentActiveChatbotThread, userDetail?.user_assignment_id);
    const actionBtnBgColor = useCallback(() => actionBtnColors.bgColor, [actionBtnColors.bgColor]);
    const actionBtnTextColor = useCallback(() => actionBtnColors.textColor, [actionBtnColors.textColor]);

    const [searchParams, setSearchParams] = useSearchParams()
    const feedback_id = searchParams.get('feedback_id')

    const mobileScreen = useMediaQuery<boolean>('(max-width : 600px) and (min-width : 0px)')
    const smallScreen = useMediaQuery<boolean>('(max-width : 1000px) and (min-width : 0px)')
    const flagShowBackArrow = useMediaQuery<boolean>('(max-width : 1000px)')

    const [flagShowAgentAssignmentInfo, setFlagShowAgentAssignmentInfo] = useState<boolean>(false);
    const agentAvatarRef = useRef<HTMLDivElement | null>(null);

    const getThreadHeaderTitle = () => {
        if (currentActiveChatbotThread) {

            const channelName = currentActiveChatbotThread?.chatbot_user_route_source ?? "";
            const isInstagram = isInstagramChannel(channelName);

            const threadMetadata = currentActiveChatbotThread?.thread_metadata;
            const name = getMetadataValue(threadMetadata, METADATA_KEYS['NAME']);

            if(isInstagram){
                const userName = getThreadInstagramUserName(threadMetadata);

                if(!name && !userName){
                    return "UNKNOWN";
                } else if (!name) {
                    return userName ?? "UNKNOWN";
                }

                const displayName = name ?? "UNKNOWN";
                return `${`\u2066${displayName}\u2069`}${userName ? ` | ${userName}` : ""}`;
            }

            const phoneNumber = getMetadataValue(threadMetadata, METADATA_KEYS['PHONE_NUMBER']);
            const formattedPhoneNumber = formatPhoneNumber(phoneNumber ?? "") ?? "";

            if(!name && !phoneNumber){
                return "UNKNOWN";
            } 
            const displayName = name ?? "UNKNOWN";
            return `${`\u2066${displayName}\u2069`}${formattedPhoneNumber ? ` | ${formattedPhoneNumber}` : ""}`
        }
    }

    const ArchiveButtonDesktopView = () => {
        const {
            threadData,
            isArchiveDisabled,
            archiveTooltip,
            handleArchiveToggle,
            buttonText
        } = getArchiveActionState();

        return (
            <Grid item>
                <GlobalTooltip placement="bottom" title={archiveTooltip} arrow>
                    <span>
                        <GlobalButton
                            sx={{
                                "&:hover": {
                                    backgroundColor: threadData?.flag_archive ? "#4CAF50" : archiveBtnBgColor,
                                },
                                color: whiteColor,
                                backgroundColor: threadData?.flag_archive ? unArchiveBtnBgColor : archiveBtnBgColor,
                                "&.Mui-disabled": { backgroundColor: archiveBtnBgColor, color: whiteColor, cursor: "not-allowed" },
                            }}
                            className=''
                            disabled={isArchiveDisabled}
                            onClick={handleArchiveToggle}
                            buttonText={buttonText}
                        />
                    </span>
                </GlobalTooltip>
            </Grid>
        );
    };

    const renderManualOverrideIcon = () => {
        const btnText = getManualOverrideConfig(currentActiveChatbotThread);
        let manualOverrideIcon = <></>;
        switch(btnText?.toLowerCase()) {
            case MANUAL_OVERRIDE_BTN_TEXT['TAKEOVER']?.toLowerCase():
                if(isChannelNameChronoxAiWebApp(currentActiveChatbotThread)){
                    manualOverrideIcon = <></>;
                } else if(checkDisabledManualOverRideBtn() && !isThreadArchived(currentActiveChatbotThread)){
                    const assignedAgents = currentActiveChatbotThread?.manual_agent_data ?? [];
                    manualOverrideIcon = renderAllAssignedAgentAvatar(assignedAgents);
                } else {
                    manualOverrideIcon = <IconsColor iconName='takeoverIcon' height={mobileScreen ? "22px" : "24px"} width={mobileScreen ? "22px" : "24px"} fillColor={isChannelNameChronoxAiWebAppOrWebsite(currentActiveChatbotThread) ? greyColor : whiteColor} />
                }
                break;
            case MANUAL_OVERRIDE_BTN_TEXT['LEAVE']?.toLowerCase():
                manualOverrideIcon = <LogoutIcon className={`${styles.leaveIcon}`} fontSize={mobileScreen ? "small" : "medium"} sx={{ color: `${isChannelNameChronoxAiWebAppOrWebsite(currentActiveChatbotThread) ? redColor : whiteColor}` }} />
                break;
            case MANUAL_OVERRIDE_BTN_TEXT['JOIN']?.toLowerCase():
                manualOverrideIcon = <IconsColor iconName='joinIcon' height={mobileScreen ? "22px" : "24px"} width={mobileScreen ? "22px" : "24px"} fillColor={isChannelNameChronoxAiWebAppOrWebsite(currentActiveChatbotThread) ? greyColor : whiteColor} />
                break;
            default:
                manualOverrideIcon = <></>;
        }
        return <>
            <div className={`${globalStyles.relativePosition}`}>
                <Grid 
                    item
                    ref={agentAvatarRef}
                    onClick={() => {
                        if(isChannelNameChronoxAiWebApp(currentActiveChatbotThread)){
                        }else if(!checkDisabledManualOverRideBtn()){
                            handleAnimationOnClickOfManualOverrideBtn(getManualOverrideConfig);
                            handleToggleManualOverride(String(userDetail.user_assignment_id), getManualOverrideConfig(currentActiveChatbotThread) == "Leave")
                        } else if(isThreadArchived(currentActiveChatbotThread)) {
                            setFlagShowAgentAssignmentInfo(true);
                        }
                    }}
                    className={`${globalStyles.displayFlex}`}
                >
                    {manualOverrideIcon}
                </Grid>
                {flagShowAgentAssignmentInfo && 
                    <ClickAwayListener onClickAway={() => setFlagShowAgentAssignmentInfo(false)}>
                        <Paper
                            elevation={3}
                            className={styles.agentAssignmentInfo}
                        >
                            <Typography className={clsx(globalStyles.tertiaryFontSize, globalStyles.secondaryFontWeight)}>
                                Cannot takeover: thread is archived
                            </Typography>
                        </Paper>
                    </ClickAwayListener>
                }
            </div>
        </>
    }

    const checkDisableVoiceCallIcon = () => {
        const threadData = currentActiveChatbotThread?.chatbot_thread_data;

        if(!threadData) return false;

        const lastVoiceCall = [...(threadData ?? [])]?.reverse()?.find((thread) => thread?.action_type_name?.toLowerCase() === ACTION_TYPE_NAME["VOICE_CALL"]?.toLowerCase());

        if(!lastVoiceCall) return false;

        const voiceCallStatus = lastVoiceCall?.action_execution_data?.whatsapp_call_status_name?.toLowerCase() ?? '';
        const completedStatuses = [
            VOICE_CALL_STATUS["COMPLETED"]?.toLowerCase(),
            VOICE_CALL_STATUS["FAILED"]?.toLowerCase(),
            VOICE_CALL_STATUS["REJECTED"]?.toLowerCase(),
        ]

        return !completedStatuses?.includes(voiceCallStatus);

    }

    const getVoiceCallIconClassName = () => {
        return clsx(checkDisableVoiceCallIcon() && styles.disableVoiceCallIcon, styles.voiceCallIconSize, (currentActiveChatbotThread && currentActiveChatbotThread.chatbot_user_route_source.toLowerCase() == "whatsapp") ? styles.chatLogMoreVertIconWhiteColor : styles.chatLogMoreVertIconPrimaryColor);
    }

    const onClickOfChevronIcon = () => {
        setFlagOpenThreadInfoBlock(true); 
        setChatInfoClicked(true); 
        setChatClicked(false)
    }

    return (
        <>
            <Grid item>
                <Grid container justifyContent={"space-between"} alignItems={"center"}>
                    <Grid item padding={flagShowBackArrow ? "15px 7px" : "15px"} className={globalStyles.fullwidth} sx={{ backgroundColor: getDynamicColorsByChatbotRouteSource().header_bg_color, color: chatBotDetails?.chatbot_theme.chatbot_send_message_font_color ? chatBotDetails?.chatbot_theme.chatbot_send_message_font_color : primaryColor }}>
                        <Grid container justifyContent={"space-between"} flexWrap={"nowrap"} alignItems={"center"} gap={mobileScreen ? "0px" : "5px"}>
                            <Grid item className={clsx(globalStyles.maxWidthFull, globalStyles.overflowHidden)}>
                                <Grid container alignItems={"center"}>
                                    <Grid item className={`${smallScreen ? mobileStyles.chatbotNameHeadingResponsive : mobileStyles.chatBotname}`}>
                                        <Grid container gap={smallScreen ? 0.5 : 1} alignItems={"center"} flexWrap={"nowrap"}>
                                            {
                                                flagShowBackArrow && !feedback_id &&
                                                <Grid item onClick={() => {
                                                    if (setChatClicked) {
                                                        setChatClicked(false);
                                                    }
                                                    setCurrentActiveChatbotThread(null)
                                                    setSearchParams((prevParams: URLSearchParams) => {
                                                        const newParams = new URLSearchParams(prevParams);
                                                        newParams.set('chatbot_user_id', "");
                                                        return newParams;
                                                    });
                                                }}><ArrowBackIcon className={globalStyles.displayFlexStyle} style={{ color: getDynamicColorsByChatbotRouteSource().header_font_color }} /></Grid>}
                                            <Grid item>
                                                {renderUserAvatarDp(getThreadHeaderTitle()?.replace(/[\u2066-\u2069]/g, "") ?? "", (isChannelNameWhatsApp(currentActiveChatbotThread) || flagRenderNewConversation) ? true : false)}
                                            </Grid>
                                            {(currentActiveChatbotThread || flagRenderNewConversation) &&
                                                <Grid item className={clsx(mobileStyles.chatbotNameHeading, globalStyles.fullwidth, globalStyles.maxWidthFull, globalStyles.overflowHidden)} sx={{ color: getDynamicColorsByChatbotRouteSource().header_font_color }}>
                                                    {currentActiveChatbotThread ? getThreadHeaderTitle() : newThreadInfo?.user_wa_phone_number}
                                                </Grid>
                                            }
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item>
                                <Grid container flexWrap={"nowrap"} alignItems={"center"} gap={mobileScreen ? "3px" : "10px"}>
                                    {shouldShowManualOverrideBtn(false) &&
                                        <Grid item>
                                        {mobileScreen ?
                                            renderManualOverrideIcon()
                                            :
                                            <GlobalTooltip
                                                title={getManualOverrideConfig(currentActiveChatbotThread)?.toLowerCase() === 'takeover' ? isThreadArchived(currentActiveChatbotThread) ? 'Cannot takeover: thread is archived' : (isConversationHandleByOtherAgent(currentActiveChatbotThread, userDetail?.user_assignment_id) && !isOnlySmbUserAssigned(currentActiveChatbotThread)) ? 'Cannot takeover: A manual agent is assigned to this thread' : '' : ''}
                                                placement='bottom'
                                                arrow
                                            >
                                                <span>
                                                    <GlobalButton
                                                        sx={{
                                                            "&:hover": {
                                                                backgroundColor: actionBtnBgColor(),
                                                            },
                                                            color: `${actionBtnTextColor()} !important`,
                                                            backgroundColor: `${actionBtnBgColor()} !important`,
                                                            boxShadow: (currentActiveChatbotThread && getManualOverrideConfig(currentActiveChatbotThread) == "Leave") ? "0px 0px 2px #BA0101 inset" : "none"
                                                        }}
                                                        className=''
                                                        disabled={checkDisabledManualOverRideBtn()}
                                                        onClick={() => {
                                                            handleAnimationOnClickOfManualOverrideBtn(getManualOverrideConfig);
                                                            handleToggleManualOverride(String(userDetail.user_assignment_id), getManualOverrideConfig(currentActiveChatbotThread) == "Leave")
                                                        }}
                                                        buttonText={getManualOverrideConfig(currentActiveChatbotThread)}
                                                    />
                                                </span>
                                            </GlobalTooltip>
                                        }
                                        </Grid>
                                    }
                                    {/* Archive/Unarchive button for Rule-Based Inbox */}
                                    {shouldShowArchiveActionBtn(false) &&
                                        ArchiveButtonDesktopView()
                                    }
                                    
                                    {/* Refresh button — visible only in rule-based inbox when a thread is open */}
                                    {flagRuleBasedInbox && currentActiveChatbotThread && onRefreshThread && (
                                        <Grid item>
                                            <GlobalTooltip placement="bottom" title="Refresh conversation" arrow>
                                                <IconButton
                                                    size="small"
                                                    onClick={onRefreshThread}
                                                    sx={{ padding: "4px" }}
                                                >
                                                    <RefreshIcon
                                                        fontSize="small"
                                                        className={`${(currentActiveChatbotThread && currentActiveChatbotThread.chatbot_user_route_source.toLowerCase() == "whatsapp") ? styles.chatLogMoreVertIconWhiteColor : styles.chatLogMoreVertIconPrimaryColor}`}
                                                    />
                                                </IconButton>
                                            </GlobalTooltip>
                                        </Grid>
                                    )}
                                    {(isVoiceCallingEnableWaba && hasInboxReadAccess(apiRoutesPermissionAssignment, userDetail) && currentActiveChatbotThread && !isChannelNameChronoxAiWebAppOrWebsite(currentActiveChatbotThread)) &&
                                        <GlobalTooltip
                                            placement='bottom'
                                            title={checkDisableVoiceCallIcon() ? 'A voice call is currently ongoing' : ''}
                                            arrow
                                        >
                                            <Grid item
                                                className={clsx(globalStyles.displayFlexStyle, globalStyles.clickable)}
                                                marginInline={"8px 0px"}
                                                onClick={() => {
                                                    if(checkDisableVoiceCallIcon()) return;
                                                    setFlagVoiceCallPopup(true)
                                                }}
                                            >
                                                <LocalPhoneOutlinedIcon className={getVoiceCallIconClassName()} />
                                            </Grid>
                                        </GlobalTooltip>
                                    }
                                    {((isAdmin(userDetail) || currentActiveChatbotThread) && !flagRenderNewConversation) &&
                                        <Grid item>
                                            <MoreVertIcon
                                                onClick={(event) => {
                                                    event.stopPropagation();
                                                    if (currentActiveChatbotThread) {
                                                        const updatedChatLevelMenu = { ...chatLevelMenu, flagOpen: true, anchorEl: event.currentTarget };
                                                        setChatlevelMenu(updatedChatLevelMenu);
                                                    }
                                                }}
                                                className={clsx(globalStyles.clickable, globalStyles.displayFlexStyle, (currentActiveChatbotThread && currentActiveChatbotThread?.chatbot_user_route_source?.toLowerCase() == "whatsapp") ? styles.chatLogMoreVertIconWhiteColor : styles.chatLogMoreVertIconPrimaryColor)}
                                            />
                                        </Grid>
                                    }
                                    {smallScreen &&
                                        <Grid item>
                                            <Grid container
                                                justifyContent={"end"} alignItems={"center"}
                                            >
                                                <ChevronLeftIcon
                                                    onClick={() => {
                                                        onClickOfChevronIcon();
                                                    }}
                                                    className={styles.chevronLeftIcon}
                                                    style={{
                                                        backgroundColor: chatBotDetails?.chatbot_theme.chatbot_header_font_color ? chatBotDetails?.chatbot_theme.chatbot_header_font_color : secondaryColor, color: chatBotDetails?.chatbot_theme.chatbot_header_color ? chatBotDetails?.chatbot_theme.chatbot_header_color : "#000000"
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            {renderChatLevelMenu()}
        </>
    )
}

export default ThreadLogHeader
